/*
 * Copyright (c) 2021. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import SendApplication from "./SendApplication";
import { Helmet } from "react-helmet-async";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import JobPageMeta from "@/src/containers/Pages/Generic/JobsPage/JobPageMeta";
import AreYouInterestedSection from "./AreYouInterestedSection";
import { gaSet } from "@/src/services/googleAnalyticsService";
import JobContainer, { JobContainerProps } from "@/src/components/Jobs/Job/JobContainer";

const serviceRafaTeamLeadJobDetails: JobContainerProps = {
  meta: <JobPageMeta />,
  title: "Teamleitung Legal Operations / Kanzleimanagement Vollzeit (m/w/d)",
  hardFacts: [
    {
      title: "Standort",
      value: "Köln, DE",
    },
    {
      title: "Beschäftigungsart",
      value: "Vollzeit",
    },
    {
      title: "Arbeitsmodell",
      value: "Hybrid",
    },
    {
      title: "Bereich",
      value: "Operations",
    },
  ],
  content: [
    {
      type: "headline",
      headline:
        "Du bist Rechtsanwaltsfachangestellte (m/w/d) mit Führungserfahrung oder hast allgemein Führungserfahrung im Kanzleiumfeld? Warum eine " +
        "Legal-Tech-Kanzlei dein nächster Karriereschritt sein sollte!",
    },
    {
      type: "text",
      text:
        "Du hast bereits Führungserfahrung als Teamleitung oder Büroleitung und möchtest ein motiviertes Team leiten? Wir bieten dir eine aufregende " +
        "Arbeitsumgebung für Rechtsanwaltsfachangestellte. Im Gegensatz zu traditionellen Kanzleien setzen wir als Legal-Tech-Kanzlei auf innovative " +
        "Technologien, die die Effizienz und Effektivität von Rechtsdienstleistungen verbessern.",
    },
    {
      type: "text",
      text:
        "Als Teil des Teams kannst du unsere eigenen Technologien nutzen und an der Entwicklung mitarbeiten oder dich einfach auf deine Fähigkeiten als " +
        "Rechtsanwaltsfachangestellte konzentrieren, ohne zeitraubende und mühsame Aufgaben erledigen zu müssen. Du hast Ideen zur Verbesserung der Abläufe " +
        "deines Teams? Dann können wir jederzeit auch unsere Software nach deinen Wünschen anpassen, damit sie dich in deiner Führungsposition unterstützt.",
    },
    {
      type: "text",
      text: "Lerne Legalbird kennen und sei dabei, wenn wir nicht nur den Rechtsmarkt, sondern auch die Arbeitsbedingungen für unser Team revolutionieren!",
    },
    {
      type: "headline",
      headline: "Was Deine Aufgaben sein werden",
    },
    {
      type: "list",
      items: [
        "Fachliche und disziplinarische Führungsverantwortung: Förderung, Motivation und Qualifizierung von Teammitgliedern durch Coachings und Feedbackgespräche",
        "Du bist der Experte in der professionellen und persönlichen Beratung für unser digitales Rechtsprodukt",
        "Kontinuierliche Weiterentwicklung und Optimierung von Prozessen, Arbeitsabläufen und Qualitätsstandards mit Unterstützung deiner direkten Kollegen und unserer Fachanwälte",
        "Aufbau und Recruiting Deines Teams",
      ],
    },
    {
      type: "headline",
      headline: "Was Du dazu brauchst",
    },
    {
      type: "list",
      items: [
        "Du hast mehrjährige Erfahrung im Rechtsbereich und bereits Führungserfahrung mit dem Talent zur Motivation von Mitarbeitern",
        "Du hast ausgezeichnete Kommunikationsfähigkeiten und eine kundenorientierte, professionelle Ausdrucksweise",
        "Du begeisterst Dich für den Rechtsbereich und hast bestenfalls eine Ausbildung zur Rechtsanwaltsfachangestellten / Notariatsfachangestellten",
        "Du bietest jeder Mandantschaft eine kompetente und persönliche Betreuung mit individuellen Lösungen",
        "Du hast Spaß daran, komplexe Sachverhalte zu verstehen und sie präzise und verständlich darzustellen",
      ],
    },
    {
      type: "headline",
      headline: "Was wir Dir bieten und was uns auszeichnet",
    },
    {
      type: "list",
      items: [
        "Eine unternehmerische und anspruchsvolle Arbeit in einem hochmotivierten Team, in dem Du Deine Karriere auf das nächste Level bringen kannst – persönliche und berufliche Weiterentwicklungsmöglichkeiten inklusive",
        "Die Chance, in einem stark wachsenden Unternehmen dabei zu sein und Verantwortung zu übernehmen",
        "Wir entscheiden und arbeiten mit vollem Kundenfokus, fakten- und ergebnisorientiert und umsetzungsstark, um unseren Kunden das bestmögliche Erlebnis zu bieten",
        "Eine tolle Arbeitsatmosphäre in modernem Büro in den Kranhäusern mit einem phantastischen Rheinblick  und sehr guter Erreichbarkeit mit ÖPNV (Deutschlandticket inklusive)",
      ],
    },
  ],
  afterContent: (
    <>
      <AreYouInterestedSection role={"Teamlead"} />
      <SendApplication />
    </>
  ),
};

const ServiceRAFATeamLead = () => {
  const title = "Jobs - Rechtsanwaltsfachangestellte Teamleitung Vollzeit | Legalbird";

  gaSet({ title: title });

  return (
    <LayoutPublicRoutes>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <JobContainer {...serviceRafaTeamLeadJobDetails} />
    </LayoutPublicRoutes>
  );
};

export default ServiceRAFATeamLead;
